import { render, staticRenderFns } from "./AdBanner.vue?vue&type=template&id=2d259c8d&scoped=true&"
import script from "./AdBanner.vue?vue&type=script&lang=js&"
export * from "./AdBanner.vue?vue&type=script&lang=js&"
import style0 from "./AdBanner.vue?vue&type=style&index=0&id=2d259c8d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d259c8d",
  null
  
)

export default component.exports